import React, { useState, useCallback, useMemo, lazy, Suspense } from "react";
import { Avatar, Dropdown } from "antd";
import { ChevronDown } from "lucide-react";
import type { MenuProps } from "antd";
import styles from "./AppHeader.module.scss";
import { useInfoMine } from "../../hooks/queries/user";

// Lazy load UserProfileModal
const UserProfileModal = lazy(() => import("./UserProfileModal"));

const AppHeader: React.FC = () => {
  const [showProfileModal, setShowProfileModal] = useState(false);
  const { data: infoMine } = useInfoMine();

  const toggleModal = useCallback(() => {
    setShowProfileModal((prev) => !prev);
  }, []);

  const handleLogoClick = useCallback(() => {
    window.location.href = "/";
  }, []);

  const userMenuItems: MenuProps["items"] = useMemo(
    () => [
      {
        key: "profile",
        label: "Thông tin cá nhân",
        onClick: toggleModal,
      },
    ],
    [toggleModal],
  );

  return (
    <>
      <header className={styles.appHeader}>
        <div className={styles.leftSection}>
          <div className={styles.logo} onClick={handleLogoClick}>
            <img src="/assets/images/logo-dark-bg.png" alt="VIAGS Logo" className={styles.logoImage} />
            <div className={styles.logoText}>
              <div className={styles.title}>VĂN PHÒNG ĐIỆN TỬ</div>
              <div className={styles.subtitle}>VIAGS EOFFICE</div>
            </div>
          </div>
        </div>

        <div className={styles.rightSection}>
          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={["click"]}>
            <div className={styles.userProfile}>
              <Avatar size={40} src={infoMine?.User?.Avatar} className={styles.avatar}>
                {infoMine?.User?.FirstName?.[0]}
              </Avatar>
              <div className={styles.userInfo}>
                <span className={styles.userName}>{infoMine?.User?.FullName}</span>
                <span className={styles.userRole}>{infoMine?.User?.Email}</span>
              </div>
              <ChevronDown size={16} className={styles.dropdownIcon} />
            </div>
          </Dropdown>
        </div>
      </header>

      {/* Lazy loaded User Profile Modal */}
      <Suspense fallback={null}>
        {showProfileModal && infoMine?.User && (
          <UserProfileModal
            data={infoMine?.User}
            visible={showProfileModal}
            onClose={() => setShowProfileModal(false)}
          />
        )}
      </Suspense>
    </>
  );
};

export default React.memo(AppHeader);
